module.exports = __webpack_public_path__ + "static/media/AnimationsBadOptimized.203fc178.mp4";